import { CrmTypes } from 'ts/enums/crm'
import { IWhatsappMessage, ISmsMessage } from 'ts/interfaces/crm'

interface ICrmReducer {
  whatsappMessages: {
    data: IWhatsappMessage[]
    total: number
    loading: boolean
  }
  smsMessages: {
    data: ISmsMessage[]
    total: number
    loading: boolean
  }
  smsBalance: {
    balance: number
    loading: boolean
  }
}

const initialState: ICrmReducer = {
  whatsappMessages: {
    data: [],
    total: 0,
    loading: false
  },
  smsMessages: {
    data: [],
    total: 0,
    loading: false
  },
  smsBalance: {
    balance: 0,
    loading: false
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: any) => {
  switch(action.type){
  case CrmTypes.LIST_WHATSAPP_MESSAGES:
    return {
      ...state, 
      whatsappMessages: {
        ...state.whatsappMessages,
        data: action.data.messages, 
        total: action.data.total
      }
    }
  case CrmTypes.SET_LOADING_WHATSAPP_MESSAGES:
    return {
      ...state,
      whatsappMessages: {
        ...state.whatsappMessages,
        loading: action.data
      }
    }
  case CrmTypes.LIST_SMS_MESSAGES:
    return {
      ...state, 
      smsMessages: {
        ...state.smsMessages,
        data: action.data.messages, 
        total: action.data.total
      }
    }
  case CrmTypes.SET_LOADING_SMS_MESSAGES:
    return {
      ...state,
      smsMessages: {
        ...state.smsMessages,
        loading: action.data
      }
    }
  case CrmTypes.SET_SMS_BALANCE:
    return {
      ...state,
      smsBalance: {
        ...state.smsBalance,
        balance: action.data
      }
    }
  case CrmTypes.SET_LOADING_SMS_BALANCE:
    return {
      ...state,
      smsBalance: {
        ...state.smsBalance,
        loading: action.data
      }
    }
  case CrmTypes.LOGOUT:
    return initialState
  default:
    return state
  }
}

